import { useEffect } from "react";
import "./FilePreviewDialog.css";

function isPdfSource({ src = "", fileName = "", contentType = "" }) {
  const hint = `${src} ${fileName} ${contentType}`.toLowerCase();
  return hint.includes(".pdf") || hint.includes("application/pdf");
}

/**
 * In-page preview for uploaded images and PDFs (no new browser tab).
 */
export default function FilePreviewDialog({
  open,
  onClose,
  title = "Document preview",
  fileName = "",
  src = "",
  contentType = "",
}) {
  const isPdf = isPdfSource({ src, fileName, contentType });

  useEffect(() => {
    if (!open) return undefined;
    function onKeyDown(event) {
      if (event.key === "Escape") onClose?.();
    }
    document.addEventListener("keydown", onKeyDown);
    const prevOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    return () => {
      document.removeEventListener("keydown", onKeyDown);
      document.body.style.overflow = prevOverflow;
    };
  }, [open, onClose]);

  if (!open || !src) return null;

  return (
    <div
      className="file-preview-dialog"
      role="dialog"
      aria-modal="true"
      aria-label={title}
      onClick={onClose}
    >
      <div
        className="file-preview-dialog__panel"
        onClick={(event) => event.stopPropagation()}
      >
        <header className="file-preview-dialog__head">
          <div className="file-preview-dialog__titles">
            <h3>{title}</h3>
            {fileName ? <span className="file-preview-dialog__file">{fileName}</span> : null}
          </div>
          <button
            type="button"
            className="file-preview-dialog__close"
            onClick={onClose}
            aria-label="Close preview"
          >
            ×
          </button>
        </header>
        <div className="file-preview-dialog__body">
          {isPdf ? (
            <iframe src={src} title={title} className="file-preview-dialog__iframe" />
          ) : (
            <img src={src} alt={title} className="file-preview-dialog__image" />
          )}
        </div>
      </div>
    </div>
  );
}
